import axios from "axios";
import router from "./router";

const api = axios.create({
  baseURL: "https://admin.from-malk.com/api",
  headers: {
    "Content-Type": "application/json",
  },
});

// 👉 Add token and lang_code to every request
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("access_token");
  const langCode = localStorage.getItem("lang_code") || "ar";

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  config.params = {
    ...config.params,
    lang_code: langCode,
  };

  return config;
});

// 👉 Response interceptor for handling expired token
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    const token = localStorage.getItem("access_token");

    // Token expired and not already retried
    if (error.response?.status === 401 && token && !originalRequest._retry) {
      originalRequest._retry = true;
      try {
        // 👉 Attempt to refresh the token
        const res = await axios.post(
          "https://admin.from-malk.com/api/v1/admin/refresh",
          {},
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        const newToken = res.data.access_token;
        localStorage.setItem("access_token", newToken);

        // 👉 Set new token on original request
        originalRequest.headers.Authorization = `Bearer ${newToken}`;

        // 👉 Retry the original request
        return api(originalRequest);
      } catch (refreshError) {
        console.error("Token refresh failed:", refreshError);
        localStorage.removeItem("access_token");
        router.push({ name: "LoginRegisterPage" });
      }
    } else if (!token || error.response?.status === 401) {
      // No token or refresh failed
      localStorage.removeItem("access_token");
      router.push({ name: "LoginRegisterPage" });
    }

    if (error.response) {
  return Promise.reject(error); 
} else {
  console.error("❌ Axios Error (No response):", error);
  return Promise.reject({
    message: "Network or unknown error",
    ...error,
  });
}
  }
);

export default api;
